import Faq from '../components/Faq'
import BreedServices from '../components/BreedServices'
import NewsLetter from '../components/NewsLetter'
import ShopAreaCat from '../components/ourshop/ShopAreaCat';
import BreadCumbcat from '../components/catlists/BreadCumb';
import { useEffect } from 'react';
import ShopAreaRongeur from '../components/ourshop/ShoAreaRongeur';
import ShopAreaBird from '../components/ourshop/ShopAreaBird';
import BreadCumbbird from '../components/catlists/BreadCrumbOiseaux';
import { Helmet } from 'react-helmet-async';


function BirdList() {
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);


    return (

        <main>
            			 <Helmet>
        <title>Oiseaux - Animalia</title>
        <meta name="description" content="Découvrez notre sélection de nos produits pour oiseaux chez Animalia." />
      </Helmet>

            <BreadCumbbird/>
            {/* <DogsList/> */}
            <ShopAreaBird />
            {/* <AdoptionShop/> */}
            <Faq afterElment="faq-area-two" />
            <BreedServices />
            <NewsLetter />
        </main>
    )
}

export default BirdList;
